// Browser-local linked-contact shortcuts. CRM owns contact identity; the
// accounting contact directory is the real list and the LinkedContactPicker
// reads it directly. This module keeps only the old local UUID shortcuts as
// an advanced /contacts entry, so a contact that predates the directory can
// still be surfaced without a CRM lookup. It is NOT a source of truth and
// never seeds document data; links persist per browser only.

export const LINKED_CONTACTS_STORAGE_KEY =
  "niche-accounting.linked-contacts.v1";

/** Browser-local list of linked CRM contact IDs. Never a source of truth. */
export function loadLinkedContactIds(): string[] {
  try {
    const raw = window.localStorage.getItem(LINKED_CONTACTS_STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === "string")
      : [];
  } catch {
    return [];
  }
}

export function saveLinkedContactIds(ids: string[]): void {
  try {
    window.localStorage.setItem(
      LINKED_CONTACTS_STORAGE_KEY,
      JSON.stringify(ids),
    );
  } catch {
    // Storage full or unavailable (private mode) — the list just won't
    // persist; callers keep working for this session.
  }
}
